
import { defineComponent } from "vue";

export default defineComponent({
  name: "Article",
  props: {
    article: {
      type: Object,
      required: true,
    },
  },
});
